import asrt_rep from "../../../../src/sv/images/wave_assert_repeatition.png";
import * as React from 'react';
export default {
  asrt_rep,
  React
};